<template>
  <div class="api-set">
    <div class="main">
      <p>Webhooks</p>
      <div class="content bg-white">
        <el-form ref="setForm" label-position="right" label-width="150px">
          <el-form-item label="URL">
            <el-input v-model.trim="url" :placeholder="$t('PersonalCenter.ApiSet.webHookHint1')" style="width: 500px;margin-right:10px;"></el-input>
            <el-button type="primary" @click="submit">{{ $t('PersonalCenter.ApiSet.Submit') }}</el-button>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.ApiSet.SigningSecret')">
            <el-input v-model="secret" disabled :show-password='showSecret' style="width: 500px;margin-right:10px;"></el-input>
            <el-button type="text" @click="show">{{ showSecret ? $t('PersonalCenter.ApiSet.Show') : $t('PersonalCenter.ApiSet.Hide') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      webHooks: null,
      url: '',
      secret: '',
      showSecret: true
    }
  },
  mounted() {
    this.getMessageWebhook()
  },
  methods: {
    getMessageWebhook() {
      API.getMessageWebhook().then(res => {
        this.secret = res.data.secret
        this.url = res.data.url
        this.webHooks = res.data
      })
    },
    show() {
      this.showSecret = !this.showSecret
    },
    submit() {
      if (!this.url) return this.$message.warning(this.$t('PersonalCenter.ApiSet.webHookHint1'))
      if (!/https:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/.test(this.url)) return this.$message.warning(this.$t('PersonalCenter.ApiSet.webHookHint2'))
      API.setMessageWebhook({ url: this.url, id: this.webHooks.id, name: '' }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.api-set {
  .main {
    >p {
      font-size: 18px;
      font-weight: bold;
      padding: 10px;
    }

    .content {
      padding: 30px;
    }
  }

}
/deep/.el-input__inner {
  border-radius: 2px !important;
}
</style>
